import jwtdecode from 'jwt-decode';

export function decodeJwtToken<TPayload = {}>(
  token: string,
): JwtToken & TPayload {
  return jwtdecode<JwtToken & TPayload>(token);
}

type JwtToken = {
  /**
   * REQUIRED. Expiration time on or after which the ID Token MUST NOT be accepted for processing. The processing of this parameter requires that the current date/time MUST be before the expiration date/time listed in the value. Implementers MAY provide for some small leeway, usually no more than a few minutes, to account for clock skew. Its value is a JSON number representing the number of seconds from 1970-01-01T0:0:0Z as measured in UTC until the date/time. See RFC 3339 [RFC3339] for details regarding date/times in general and UTC in particular.
   */
  exp: number; // 1542709842
  /**
   * REQUIRED. Issuer Identifier for the Issuer of the response. The iss value is a case sensitive URL using the https scheme that contains scheme, host, and optionally, port number and path components and no query or fragment components.
   */
  iss: string;
  username: string;
  userid: number;
};
